import {useCallback, useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Range} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/components/Range/Range';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {selectEditorDisabled} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';

export const LineHeight = () => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const [lineHeight, setLineHeight] = useState();
  const editorDisabled = useSelector(selectEditorDisabled);

  useEffect(() => {
    const updateLineHeight = () => setLineHeight(canvas?.getActiveObjects()?.[0]?.lineHeight);

    updateLineHeight();
    canvas?.on('object:reset', updateLineHeight);

    return () => {
      canvas?.off('object:reset', updateLineHeight);
    };
  }, [canvas, activeObjects]);

  const onChangeHandler = useCallback(
    (value) => {
      activeObjects.forEach((obj) => {
        setLineHeight(value);
        obj.set('lineHeight', value);
      });

      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [activeObjects]
  );

  return (
    <Range
      min={1}
      max={4}
      step="0.1"
      value={lineHeight}
      onChange={onChangeHandler}
      disabled={editorDisabled}
      dataQaId="step1-textheight-range"
    />
  );
};
